import React from 'react'
import firebase from 'firebase'
import {Button, Textfield, ProgressBar} from 'react-mdl'
import {currentUser} from 'firebase-main'
import {removeLeaf} from 'utils'

import './myoffers.css'

const debug = false
const debugState = false


export default class Profile extends React.PureComponent {

  constructor(props) {
    super(props)

    firebase.database().ref('userbids/' + currentUser().uid + '/auctions')
    // .once(  'value',  snapshot => this.setState({ bids: snapshot.val() })  )
    .once(  'value',  snapshot => this.setState(snapshot.val())  )

    // firebase
    //   .database()
    //   .ref('userbids/' + currentUser().uid + '/auctions')
    //   .on('child_added',   snapshot => console.debug('snapshot', snapshot.val()) )

    // firebase.database().ref('userbids/' + currentUser().uid + '/auctions')
  }

  removeBid = path => {
    firebase.database().ref('auctions/'+path).remove()
    firebase.database().ref('userbids/' + currentUser().uid + '/auctions/' + path).remove()

    removeLeaf(this.state, path)
    this.forceUpdate()
  }

  render() {
    if (!this.state) return <ProgressBar className='pageLoader' title='loading from firebase' indeterminate/>
    if (debug) console.debug('%crender offers', 'background: #c34ff7; color: #bada55', this.state)

    const kinds = Object.keys(this.state)
    const mapped = (
      kinds.map(kind => {
        if (debugState) console.debug('kind', kind, this.state[kind])
        const items = Object.keys(this.state[kind])
        return (
          <div key={kind} className="post full post--KvwRr5wMp4e4nMQsgc0 mdl-cell mdl-cell--12-col mdl-cell--6-col-tablet mdl-cell--4-col-desktop mdl-grid mdl-grid--no-spacing">
            <div className="mdl-card full mdl-shadow--2dp">
              <div className="mdl-card__title mdl-color--light-blue-600 mdl-color-text--white">
                <h4 className="mdl-card__title-text">{kind}</h4>
              </div>
              <div className='column'>

              { items.map(item => {
                  if (debugState) console.debug('> item', item, this.state[kind][item])
                  const tiers = Object.keys(this.state[kind][item])
                  return tiers.map(tier => {
                    if (debugState) console.debug('> > tier', tier, this.state[kind][item][tier])
                    const actions = Object.keys(this.state[kind][item][tier])
                    return actions.map(action => {
                      if (debugState) console.debug('> > > action', action, this.state[kind][item][action])
                      const bids = Object.keys(this.state[kind][item][tier][action])
                      return bids.map((bid, bi, ar) => {
                        const path = [kind, item, tier, action, bid].join('/')
                        if (debugState) console.debug('> > > > bid', bid, path)
                        return (
                          <div key={bid} className='row'>
                            <div className='controls'>
                              <Button onClick={() => this.removeBid(path)} className='mdl-color--red-400' raised accent ripple>remove</Button>
                            </div>
                            <div className='option'>
                              <div>{item}</div>
                              <div>{tier}</div>
                              <div>{action}</div>
                            </div>
                            <Value path={path}/>
                          </div>
                        )
                      })
                    })
                  })
                })
              }

              </div>
            </div>
          </div>
        )
      })
    )

    return (
      <div className="my-offers posts-container mdl-cell mdl-cell--12-col mdl-grid">
        {mapped}
      </div>
    )
  }
}

class Value extends React.PureComponent {
  constructor(props) {
    super(props)
    firebase.database().ref('auctions/' + this.props.path).once(  'value',  snapshot => this.setState(snapshot.val())  )
  }

  updateInFirebase = (e) => {
    const inputQuantity = this.amount.inputRef
    const inputPrice = this.price.inputRef

    if (!inputQuantity.checkValidity() || !inputPrice.checkValidity()) return

    const quantity = Number(inputQuantity.value)
    const price = Number(inputPrice.value)
    const calculatedTotal = Math.round(quantity * price)

    this.setState({calculatedTotal})

    firebase.database().ref('auctions/' + this.props.path).update({
      quantity,
      price,
      priceTotal: calculatedTotal
    });
  }

  render() {
    if (!this.state) return <ProgressBar className='itemLoader' title='loading from firebase' indeterminate/>

    const {quantity, price, priceTotal, calculatedTotal} = this.state

    return (
      <div className='value'>
        {/* path */}
        <Textfield
          id='amount'
          title='amount'
          label="amount"
          type='number'
          step={1}
          pattern='[0-9]+'
          defaultValue={quantity}
          onChange={this.updateInFirebase}
          ref={r => this.amount = r}
        />
        <Textfield
          id='price'
          title='price'
          label="price"
          type='number'
          step={0.01}
          pattern='.+'
          defaultValue={price}
          onChange={this.updateInFirebase}
          ref={r => this.price = r}
        />
        <span>total: {calculatedTotal || priceTotal}</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/pages/Myoffers.jsx